import {usePharmacyDetails} from './hooks';
import Headline from 'components/atoms/typography/headline/headline.component';
import {
  TypographyFontStyles,
  TypographySizes,
} from 'components/atoms/typography/base-text/constants';
import Clickable from 'components/atoms/button/clickable/clickable.component';
import {useCallback} from 'react';
import COLORS from 'theme/colors/colors';

const PharmacyDetails = () => {
  const {drugCategories, navigateToDrugList: navigateToDrugDetails} =
    usePharmacyDetails();

  const renderCategories = useCallback(
    () =>
      drugCategories.map((val) => (
        <Clickable
          key={val}
          onClick={() => navigateToDrugDetails(val)}
          style={{
            flexDirection: 'column',
            display: 'flex',
            flex: 1,
            borderColor: '#3e3e3e',
            borderWidth: 3,
            borderStyle: 'solid',
            backgroundColor: COLORS.blackHighTransparent,
            justifyContent: 'center',
            alignItems: 'center',
            margin: 15,
          }}>
          <Headline
            size={TypographySizes['3XL']}
            stringProps={{plainText: val}}
          />
        </Clickable>
      )),
    [drugCategories, navigateToDrugDetails],
  );

  return (
    <div>
      <div style={{padding: 25}}>
        <Headline
          stringProps={{plainText: 'Drug Categories'}}
          size={TypographySizes['3XL']}
          fontStyle={TypographyFontStyles.Bold}
        />
      </div>
      <div style={{flexDirection: 'row', display: 'flex'}}>
        {renderCategories()}
      </div>
    </div>
  );
};

export default PharmacyDetails;
